import { Panel } from 'react-resizable-panels';

const FillPanel: React.FC = ({children}) => <Panel>{children}</Panel>;

export default FillPanel;
